import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { addUser, checkUserExistenceAPI, DeleteUserAPI, getAllRolesAPI, GetBranches, GetCountry, GetGenders, getRolesAPI, getTableColumnNames, GetUsers, ToggleStatusAPI, updateUserAPI, updateUserRoleAPI } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Users Table Column Names
export const fetchUsersTableColumnNames = createAsyncThunk(
  "users/fetchUsersTableColumnNames",
  async (users, thunkAPI) => {    
    try {
      const response = await getTableColumnNames(users); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);


// Get Page Permission Data
export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (users, thunkAPI) => {
    try {
      const response = await GetUsers(users);
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Get Braches
export const fetchBranches = createAsyncThunk(
  "branches/fetchBranches",
  async (thunkAPI) => {
    try {
      const response = await GetBranches(); 
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Add User 
export const createUser = createAsyncThunk("user/addUser", async (user, thunkAPI) => {  
  try {
    const response = await addUser(user);
    
    if (response.success) {
      toast.success(t(response.message));
    } else {
      toast.error(t(response.message) || "Failed to create user.");
    }

    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(message);
  }
});


// update user 

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async (user, thunkAPI) => {
    try {
      const response = await updateUserAPI(user);

      if (response.success) {
        toast.success(t(response.message));
        return response.data;
      } else {
        // toast.error(response.message);
        return thunkAPI.rejectWithValue(response);
      }
    } catch (error) {

      toast.error(error);
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

export const activateDeactivateUser = createAsyncThunk(
  "user/toggleStatus",
  async (data, thunkAPI) => {
    try {
      const response = await ToggleStatusAPI(data);

      if (response.success) {
        toast.success(t(response.message));
        // Return just enough to update UI
        return { ID: data.ID, IsActive: data.IsActive };
      } else {
        toast.error(t(response.message));
        return thunkAPI.rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

export const deleteUser = createAsyncThunk("user/deleteUser", async (role, thunkAPI) => {
  try {
    const response = await DeleteUserAPI(role);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    toast.error(error.message)
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Thunk to fetch all roles
export const fetchRoles = createAsyncThunk(
  "roles/fetch",
  async (logs, thunkAPI) => {
    try {
      const response = await getRolesAPI(logs);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Check User Existence
export const CheckUserExistence = createAsyncThunk(
  "users/checkUserExistence",
  async (payload, thunkAPI) => { 
  try {
    const response = await checkUserExistenceAPI(payload);

    const fieldName = payload.Email ? 'Email' : (payload.Mobile ? 'Mobile' : 'Unknown');
    const fieldValue = payload.Email || payload.Mobile;

    if (response.success) {

      const userExists = typeof response.data?.exists === 'boolean' ? response.data.exists : response.exists;

      if (typeof userExists === 'boolean') {
        return {
          exists: userExists,
          field: fieldName,
          value: fieldValue,
          message: response.message,
        };
      }
    }
    const errorMessage = response.message || `Failed to check ${fieldName} existence.`;
    toast.error(errorMessage);
    return thunkAPI.rejectWithValue({ error: errorMessage, field: fieldName, value: fieldValue });
  } catch (error) {
    const errorMessage = typeof error === 'string' ? error : (error?.message || "An unexpected error occurred.");
    const fieldName = payload.Email ? 'Email' : (payload.Mobile ? 'Mobile' : 'Unknown');
    const fieldValue = payload.Email || payload.Mobile;
    return thunkAPI.rejectWithValue(error);
  }
});

export const resetUsers = createAsyncThunk("reset/resetUsers", async (role, thunkAPI) => {
  return [];
});

// update user role
export const updateUserRole = createAsyncThunk(
  "user/updateUserRole",
  async (user, thunkAPI) => {
    try {
      const response = await updateUserRoleAPI(user);

      if (response.success) {
        toast.success(t(response.message));
        return response.data;
      } else {
        toast.error(t(response.message));
        return thunkAPI.rejectWithValue(response);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);